import { FieldDeletedEvent } from '../event/field-deleted.event';
const fieldDeletedProjections = {
    [FieldDeletedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            deleted: payload.deleted,
        };
    },
};
export default fieldDeletedProjections;
//# sourceMappingURL=field-deleted.projection.js.map